import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Shield, BookMarked } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/api/auth/admin-login', {
        email,
        password
      });

      const { token, user } = response.data;
      
      // Debug log
      console.log('Admin login response:', { token: token ? 'present' : 'missing', user });

      if (user.role !== 'admin') {
        console.error('Role check failed:', user.role);
        toast.error(`Acesso negado. Role atual: ${user.role}`);
        return;
      }

      login(token, user);
      toast.success(`Bem-vinda(o), ${user.name}!`);
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#001f75] to-[#002FA7] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-2xl p-8">
          {/* Logo */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-[#002FA7] text-white">
              <BookMarked className="h-7 w-7" strokeWidth={1.5} />
            </div>
            <h1 className="text-2xl font-bold tracking-tighter text-[#002FA7]">
              Quero Publicar
            </h1>
          </div>

          {/* Admin Badge */}
          <div className="flex items-center justify-center gap-2 mb-6 py-2 px-4 bg-red-50 border border-red-200 rounded-lg">
            <Shield className="h-5 w-5 text-red-600" />
            <span className="text-sm font-semibold text-red-600">Área Administrativa</span>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email do Administrador</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@queropublicar.org"
                required
                className="mt-2"
              />
            </div>

            <div>
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="mt-2"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 py-6"
            >
              {loading ? 'Entrando...' : 'Entrar como Admin'}
            </Button>
          </form>

          <p className="mt-6 text-center text-xs text-gray-500">
            Esta página é restrita a administradores do sistema.
            <br />
            Usuários comuns devem usar o{' '}
            <a href="/auth" className="text-[#002FA7] hover:underline">login padrão</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
